import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileText, PlusCircle, CreditCard, Users, Store, ScrollText, LogOut, Plane } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ROLE_LABEL } from "@/lib/constants";

const NAV = {
  agent: [
    { to: "/", label: "My Dashboard", icon: LayoutDashboard, end: true },
    { to: "/bookings", label: "My Bookings", icon: FileText },
    { to: "/bookings/new", label: "New Booking", icon: PlusCircle },
  ],
  payment_team: [
    { to: "/payment-desk", label: "Payment Desk", icon: CreditCard },
    { to: "/bookings", label: "All Bookings", icon: FileText },
  ],
  admin: [
    { to: "/", label: "Analytics", icon: LayoutDashboard, end: true },
    { to: "/bookings", label: "All Bookings", icon: FileText },
    { to: "/payment-desk", label: "Payment Desk", icon: CreditCard },
    { to: "/users", label: "Agents & Users", icon: Users },
    { to: "/merchants", label: "Merchants", icon: Store },
    { to: "/audit", label: "Audit Logs", icon: ScrollText },
  ],
};

export default function Shell() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const items = NAV[user.role] || [];

  return (
    <div className="min-h-screen flex bg-slate-950">
      <aside className="w-60 shrink-0 border-r border-slate-800 bg-slate-900/60 flex flex-col sticky top-0 h-screen" data-testid="sidebar">
        <div className="flex items-center gap-3 px-5 h-16 border-b border-slate-800">
          <div className="h-8 w-8 rounded-md bg-indigo-600 grid place-items-center"><Plane className="h-4 w-4" /></div>
          <div className="font-display font-bold leading-none">Tramint Ops</div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end} data-testid={`nav-${it.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${isActive ? "bg-indigo-600/15 text-indigo-200 border border-indigo-500/30" : "text-slate-400 hover:text-slate-100 hover:bg-slate-800/70 border border-transparent"}`}>
              <it.icon className="h-4 w-4" /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-800">
          <div className="text-sm font-medium truncate" data-testid="current-user-name">{user.name}</div>
          <div className="text-xs text-slate-500 mb-3" data-testid="current-user-role">{ROLE_LABEL[user.role]}</div>
          <button data-testid="logout-btn" onClick={() => { logout(); nav("/login"); }}
            className="flex items-center gap-2 text-sm text-slate-400 hover:text-rose-300 transition-colors">
            <LogOut className="h-4 w-4" /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0 p-6 lg:p-8"><Outlet /></main>
    </div>
  );
}
